module.exports = __webpack_public_path__ + "static/media/FooterLogos.8b8579e9.svg";